const data = [];

data.push({
    name: "数据统计",
    class: "el-icon-pie-chart",
    path: "/DataStatistics",
});

data.push({
    name: "用户信息",
    class: "iconfont icon-zhengjian",
    path: "/TourManagement",
});

data.push({
    name: "信息上传",  
    class: "el-icon-user",
    children: [{
        name: "签运详情",
        path:"/duoshouDetails",
    },{
        name: "图片上传",
        path:"/PictureSave"
    }]
});

// 个人预测
data.push({
    name: "个人预测",
    class: "el-icon-view",
    children: [{
        name: "类别维护",
        path: "/CategoryManagement",
    }, {
        name: "项目维护",
        path: "/ProjectManagement",
    }, {
        name: "数据维护",
        path: "/DataManagement",
    }, {
        name: "测算记录",
        path: "/ResultManagement",
    }, {
        name: "测算测试",
        path: "/ResultTest",
    }]
});

// 专家管理
data.push({
    name: "专家管理",
    class: "el-icon-notebook-1",
    children: [{
        name: "专家信息",
        path: "/ExpertInformation",
    }, {
        name: "评价管理",
        path: "/EvaluationManagement",
    }, {
        name: "咨询管理",
        path: "/ConsultingManagement",
    }, {
        name: "聊天管理",
        path: "/ChatManagement",
    }]
});

// 课程管理
data.push({
    name: "课程管理",
    class: "el-icon-reading",
    children: [{
        name: "课程信息",
        path: "/CourseInformation",
    }, {
        name: "报名管理",
        path: "/AppointmentManagement",
    }]
});

data.push({
    name: "账单明细",
    class: "iconfont icon-caigoudan",
    path: "/BillDetails",
});

data.push({
    name: "价格管理",
    class: "iconfont icon-chaopiao",
    path: "/PriceManagement",
});

data.push({
    name: "用户管理",
    class: "el-icon-user",
    children: [{
        name: "用户信息",
        path: "/UserInfo",
    }, {
        name: "部门配置",
        path: "/UserDept",
    }, {
        name: "角色配置",
        path: "/UserRole",
    }, {
        name: "页面权限",
        path: "/UserPage",
    }, {
        name: "操作权限",
        path: "/UserOperate",
    }]
});

data.push({
    name: "系统配置",
    class: "el-icon-setting",
    children: [
        {
            name: "通知公告",
            path: "/BasicNotice",
        }, {
            name: "文件共享",
            path: "/BasicShare",
        }, {
            name: "单选配置",
            path: "/BasicType1",
        }, {
            name: "多选配置",
            path: "/BasicType2",
        }, {
            name: "参数设置",
            path: "/BasicParam",
        }
    ]
});

data.push({
    name: "日志审计",
    class: "el-icon-tickets",
    children: [{
        name: "用户登录",
        path: "/LogLogin",
    }, {
        name: "用户操作",
        path: "/LogOperate",
    }, {
        name: "上传文件",
        path: "/LogUpload",
    }, {
        name: "下载文件",
        path: "/LogDownLoad",
    }, {
        name: "传输日志",
        path: "/LogJson",
    }, {
        name: "应用日志",
        path: "/LogApp",
    }, {
        name: "服务监控",
        path: "/LogServer",
    }, {
        name: "服务异常",
        path: "/LogException",
    }
    ]
});

export default data;